import React from 'react';
export function Header() {
  return <header className="px-6 md:px-12 lg:px-20 py-8 md:py-10 flex flex-wrap items-baseline justify-between gap-x-8 gap-y-4 max-w-[88rem] mx-auto" data-id="element-27" data-mp="1l9wpac38z08e">
      <div className="font-serif text-2xl text-ink" data-id="element-28" data-mp="2ilquen6cd97t">
        Vera{' '}
        <span className="font-label text-[0.55rem] tracking-[0.3em] uppercase align-middle ml-1 text-graphite" data-id="element-29" data-mp="2ink122gyftft">
          Wellness Co.
        </span>
      </div>
      <nav className="flex items-baseline gap-5 md:gap-10" data-id="element-30" data-mp="2rldxreimsp3i">
        <a href="https://reserve.verawellnessco.com" className="label text-graphite/70 hover:text-ink transition-colors" data-id="element-31" data-mp="2wkyx3q1pqzgr">
          Reserve
        </a>
        <a href="#tiers" className="label text-graphite/70 hover:text-ink transition-colors" data-id="element-32" data-mp="31eba12x15hto">
          The Work
        </a>
        <a href="#ashley" className="label text-graphite/70 hover:text-ink transition-colors" data-id="element-33" data-mp="3bbfxr76ixlcl">
          Ashley
        </a>
        <a href="https://form.jotform.com/262155460714050" target="_blank" rel="noopener noreferrer" className="label accent border-b border-[#6e7f53] pb-0.5 hover:text-ink hover:border-ink transition-colors" data-id="element-34" data-mp="2wkupx3y541b1">
          Get in Touch
        </a>
      </nav>
    </header>;
}